// extracted by mini-css-extract-plugin
export default {"pointer":"TableItem_pointer__AAFuu","text":"TableItem_text__SPqVl"};